import { CoreMenuCategoryPage } from 'src/dispensary/core-menu/category';
import { getCategoryServerSideProps } from 'src/utils/ssr/get-category-server-side-props';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export const getServerSideProps = getCategoryServerSideProps;

export default withLayout(CoreMenuCategoryPage, CoreMenuLayout);
